'use client';

import { getParentLink } from '../../../utils/getParentLink';
import { useCommonData } from '../../../common-data/useCommonData';
import { IPageEntry } from '../../../contentful/types/IPage';
import ContentPageHeader from './ContentPageHeader';
import { HeaderImageVariants } from './HeaderImage';

interface IPageHeader {
	page: IPageEntry;
	backlink?: string;
	backlinkText?: string;
	hideHeaderImage?: boolean;
	siteSectionId?: string;
	title?: string;
	headerImageVariant: HeaderImageVariants;
}

export default function PageHeader({
	backlink,
	backlinkText,
	hideHeaderImage,
	page,
	siteSectionId,
	title: propTitle,
	headerImageVariant,
}: IPageHeader) {
	const { pathToPageIdMap } = useCommonData();

	const { headerImage, title, parent, id } = page.fields;
	const headerImageUrl = headerImage?.fields.file.url;
	const headerImageAlt = headerImage?.fields.title || ''; // Empty string by default
	const backLink = backlink || getParentLink(page, pathToPageIdMap);
	const linkTitle = backlinkText || page.fields.parent?.fields.title;

	const sectionId = siteSectionId || parent?.fields?.id || id;
	return (
		<ContentPageHeader
			hideHeaderImage={hideHeaderImage}
			headerImageUrl={headerImageUrl}
			imageAlt={headerImageAlt}
			title={propTitle || title}
			backLink={page.fields.isLandingPage ? undefined : backLink}
			backLinkText={linkTitle}
			siteSectionId={sectionId}
			headerImageVariant={headerImageVariant}
		/>
	);
}
